import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactResizeDetector from 'react-resize-detector'
import _ from 'lodash'

import { SmoothScrollbar } from 'gnos-scrollbar'

import { MENU_ITEM_KEYS } from '../../constants'

import Loader from './components/Loader'

import GeneralSettings from './components/GeneralSettings'
import EditProfile from './components/EditProfile'
import ChangePassword from './components/ChangePassword'
import HistoryReport from './components/HistoryReport'
import HistoryDistraint from './components/HistoryDistraint'
import HistoryPortfolio from './components/HistoryPortfolio'
import Importer from './components/Importer'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Content extends Component {
    static propTypes = {
        contentPath: PropTypes.array.isRequired,
        setContentHeight: PropTypes.func.isRequired,
    }

    handleOnResize = (width, height) => {
        const { setContentHeight } = this.props

        setContentHeight(height)
    }

    renderContent = () => {
        const { contentPath } = this.props

        switch (_.last(contentPath)) {
            case MENU_ITEM_KEYS.GENERAL:
                return <GeneralSettings id={MENU_ITEM_KEYS.GENERAL} />
            case MENU_ITEM_KEYS.EDIT_PROFILE:
                return <EditProfile id={MENU_ITEM_KEYS.EDIT_PROFILE} />
            case MENU_ITEM_KEYS.CHANGE_PASSWORD:
                return <ChangePassword id={MENU_ITEM_KEYS.CHANGE_PASSWORD} />
            case MENU_ITEM_KEYS.HISTORY_REPORT:
                return <HistoryReport id={MENU_ITEM_KEYS.HISTORY_REPORT} />
            case MENU_ITEM_KEYS.HISTORY_DISTRAINT:
                return <HistoryDistraint id={MENU_ITEM_KEYS.HISTORY_DISTRAINT} />
            case MENU_ITEM_KEYS.HISTORY_PORTFOLIO:
                return <HistoryPortfolio id={MENU_ITEM_KEYS.HISTORY_PORTFOLIO} />
            case MENU_ITEM_KEYS.IMPORTER:
                return <Importer id={MENU_ITEM_KEYS.IMPORTER} />
            default:
                return _.join(this.props.contentPath, ' ')
        }
    }

    render() {
        const { contentPath } = this.props

        return (
            <div className={'user-profile-content'}>
                <ReactResizeDetector
                    handleHeight
                    onResize={this.handleOnResize}
                    refreshMode={'debounce'}
                    refreshRate={100}
                />
                <Loader contentId={_.last(contentPath)} />
                <SmoothScrollbar className={'profile-content-scrollbar'}>{this.renderContent()}</SmoothScrollbar>
            </div>
        )
    }
}
